let n = [];
const a = /* @__PURE__ */ new WeakMap();
function r() {
  n.forEach((e) => e(...a.get(e))), n = [];
}
function s(e, ...t) {
  a.set(e, t), !n.includes(e) && n.push(e) === 1 && requestAnimationFrame(r);
}
export {
  s as beforeNextFrameOnce
};
